import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card"
import { useNavigate } from "react-router-dom"
import EventCardImage from "./EventCardImage";
import EventCardBody from "./EventCardBody";
import "../styles/EventCard.css"

/**
 * Event card with thumbnail, name and date
 */
const EventCard = ({ event, imageFirst }) => {
    const navigate = useNavigate()

    const handleCardClick = () => {
        navigate(`/event/${event._id}`)
    }

    return (
        <Row className="BREIKKI-event-card-container">
            <Card className="BREIKKI-event-card" onClick={handleCardClick}>
                {
                    imageFirst ? (
                        <Row className="g-0 w-100" style={{ width: "100%", height: '100%' }}>
                            <Col xs={7} style={{ height: '100%' }}>
                                <EventCardImage imageSrc={event.fileUrl} />
                            </Col>
                            <Col xs={5} style={{ height: '100%' }}>
                                <EventCardBody event={event} />
                            </Col>
                        </Row>
                    ) : (
                        <Row className="g-0 w-100" style={{ width: "100%", height: '100%' }}>
                            <Col xs={5} style={{ height: '100%' }}>
                                <EventCardBody event={event} />
                            </Col>
                            <Col xs={7} style={{ height: '100%' }}>
                                <EventCardImage imageSrc={event.fileUrl} />
                            </Col>
                        </Row>
                    )
                }
            </Card>
        </Row>
    )
}


export default EventCard